import React from 'react';
import PropTypes from 'prop-types';
import { Text, View, TouchableOpacity } from 'react-native';

import { RadioButton, CheckBox } from '../../ui'
import { styles } from './Styles';

const WorkoutSettingSection = ({
  title,
  subtitle,
  onPress,
  isActiveSetting,
  icon,
  containerStyle,
  subtitleStylesOverride,
  radioContainerOverride,
  iconContainerWithTitleStyles,
  subtitleIconContainer,
  selector = 'Radio',
  disabled,
}) => (
    <TouchableOpacity disabled={disabled} onPress={onPress} style={[styles.settingsButton, containerStyle]}>
      <View style={[styles.settingsRadioContainer, radioContainerOverride]}>
        {selector === 'Radio' ?
          <RadioButton
            disabled={disabled}
            toggleSelection={onPress}
            isSelected={isActiveSetting}
          /> :
          <CheckBox
            size={25}
            isActive={isActiveSetting}
            onPress={onPress}
            halfSelect={false}
            disabled={disabled}
          />
        }
      </View>
      <View style={[styles.buttonInformationContainer, subtitleIconContainer]}>
        <View style={[styles.settingsImageContainer, iconContainerWithTitleStyles]}>
          <View style={styles.settingsIconContainer}>
            {icon}
          </View>
          <Text style={styles.settingsTitle}>{title}</Text>
        </View>
        {subtitle &&
          <Text style={[styles.settingsSubtitle, subtitleStylesOverride]}>{subtitle}</Text>
        }
      </View>
    </TouchableOpacity>
  );

WorkoutSettingSection.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  onPress: PropTypes.func.isRequired,
  isActiveSetting: PropTypes.bool.isRequired,
  icon: PropTypes.element.isRequired,
  containerStyle: PropTypes.object,
  subtitleStylesOverride: PropTypes.object,
  radioContainerOverride: PropTypes.object,
  iconContainerWithTitleStyles: PropTypes.object,
  selector: PropTypes.oneOf(['Radio', 'Checkbox'])
};

export default WorkoutSettingSection;
